import React from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import NewSelect from "../../../shared/forms/NewSelect";
import useStore from "../store";

const Wrapper = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${({ theme }) => theme.breakpoints.from.medium.css`
            width: unset;
    `}
`;

const Sort = () => {
    const { availableSortings, sort, setSort } = useStore(
        (state) => ({
            availableSortings: state.availableSortings,
            sort: state.sort,
            setSort: state.setSort,
        }),
        shallow
    );

    return (
        <Wrapper>
            <NewSelect
                name="sort"
                minWidth="200px"
                fullwidth
                placeholder={"Sortieren"}
                value={sort.key}
                options={availableSortings.map((item) => {
                    return {
                        value: item.key,
                        text: item.label,
                    };
                })}
                onChange={(event: { target: { value: any } }) =>
                    setSort(
                        availableSortings.find(
                            (item) => item.key === event.target.value
                        )
                    )
                }
            />
        </Wrapper>
    );
};

export default Sort;
